import { Link, useLocation } from "react-router-dom";
import { RefreshCw, Landmark, ScrollText } from "lucide-react";
import { Button } from "../components/ui/button";
import { HOME } from "../constants/testIds";
import { dateBR } from "../lib/api";

export default function Header({ onRefresh, refreshing, status }) {
  const location = useLocation();
  const isDetail = location.pathname.startsWith("/pessoa");

  return (
    <header
      data-testid={HOME.header}
      className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-6 px-6 py-4 md:px-10">
        <Link
          to="/"
          className="group flex items-center gap-3"
          data-testid="brand-link"
        >
          <div className="relative flex h-9 w-9 items-center justify-center rounded-sm border border-emerald-800/20 bg-emerald-900">
            <ScrollText
              className="h-4 w-4 text-amber-400"
              aria-hidden="true"
            />
            <span
              className="absolute -bottom-0.5 -right-0.5 h-2 w-2 rounded-full bg-amber-500 ring-2 ring-white"
              aria-hidden="true"
            />
          </div>
          <div className="leading-tight">
            <div className="overline text-emerald-900">Ranking</div>
            <div className="text-lg font-bold font-display text-slate-900">
              Transparência{" "}
              <span className="text-emerald-800">BR</span>
            </div>
          </div>
        </Link>

        <nav className="hidden items-center gap-2 md:flex">
          <Link
            to="/"
            className="rounded-sm px-3 py-1.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
            data-testid="nav-home"
          >
            Ranking
          </Link>
          <a
            href="https://portaldatransparencia.gov.br"
            target="_blank"
            rel="noreferrer"
            className="rounded-sm px-3 py-1.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
            data-testid="nav-source"
          >
            Fonte Oficial
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {status?.last_success_at && !isDetail && (
            <div
              className="hidden text-right text-[11px] leading-tight text-slate-500 md:block"
              data-testid={HOME.refreshStatus}
            >
              <div className="overline text-slate-400">Última atualização</div>
              <div>{dateBR(status.last_success_at)}</div>
            </div>
          )}
          {onRefresh && (
            <Button
              variant="outline"
              size="sm"
              className="border-emerald-800 text-emerald-900 hover:bg-emerald-50 hover:text-emerald-900"
              onClick={onRefresh}
              disabled={refreshing}
              data-testid={HOME.refreshButton}
            >
              <RefreshCw
                className={`mr-2 h-3.5 w-3.5 ${refreshing ? "animate-spin" : ""}`}
                aria-hidden="true"
              />
              {refreshing ? "Atualizando..." : "Atualizar dados"}
            </Button>
          )}
        </div>
      </div>
      {refreshing && <div className="progress-line" aria-hidden="true" />}
    </header>
  );
}
